import React, { useState } from "react";
import { FaEnvelopeOpenText } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./PathToSuccess.css";

const PathToSuccess = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setError("");
    setTermsAccepted(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      setError("Por favor, ingresa un email válido.");
      return;
    }

    if (!termsAccepted) {
      setError("Debes aceptar los términos y condiciones antes de enviar.");
      return;
    }

    setIsLoading(true);
    setError("");

    const emailParams = {
      from_name: formData.fullName,
      from_email: formData.email,
      message: formData.message,
    };

    const serviceID = "thorne-mail-sender";
    const templateID = "contact_form_thorne";
    const userID = "user_s4ksp8kthXIPpoKDWLJp9";

    emailjs
      .send(serviceID, templateID, emailParams, userID)
      .then(() => {
        alert("Mensaje enviado con éxito");
        setIsModalOpen(false);
        setFormData({ fullName: "", email: "", message: "" });
        setTermsAccepted(false);
      })
      .catch((error) => {
        console.error("Error al enviar el mensaje:", error);
        setError("Ocurrió un error al enviar el mensaje, intenta nuevamente.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section className="path-to-success-container">
      <h2 className="path-to-success-title">Comienzo Tu Camino al Éxito en Dubái</h2>
      <div className="path-to-success-body">
        <p>
          La oportunidad que estabas esperando está a solo un clic de distancia. Ya sea que busques invertir en propiedades, explorar opciones de residencia o recibir asesoramiento estratégico sobre el mercado inmobiliario, Thorne Global está aquí para guiarte.
        </p>
        <p>
          Da el primer paso hacia tus objetivos en Dubái y descubre cómo podemos ayudarte a transformar tus planes en realidades, o comunícate con nuestro equipo para obtener asistencia personalizada.
        </p>
      </div>
      <div className="path-to-success-button-container">
        <button className="path-to-success-button" onClick={toggleModal}>Contactanos</button>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <FaEnvelopeOpenText className="modal-icon" />
            <h3 className="modal-title">Contactanos</h3>

            {error && <p className="error-message">{error}</p>}

            <form className="contact-form" onSubmit={handleSubmit}>
              <label htmlFor="fullName">Nombre Completo</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Tu nombre completo"
                value={formData.fullName}
                onChange={handleChange}
                required
              />

              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Tu correo electrónico"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label htmlFor="message">Mensaje</label>
              <textarea
                id="message"
                name="message"
                rows="4"
                placeholder="Escribe tu mensaje aquí..."
                value={formData.message}
                onChange={handleChange}
                required
              />

              <div className="terms-container">
                <input
                  type="checkbox"
                  id="terms"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <label htmlFor="terms" className="terms-label">
                  <a
                    href="https://www.thorneglobalrealestate.com/terms-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Términos y condiciones
                  </a>
                </label>
              </div>

              <button type="submit" className="modal-submit-button" disabled={isLoading}>
                {isLoading ? "Enviando..." : "Enviar"}
              </button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default PathToSuccess;